import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONFIG, DISCLAIMER } from "../data/content";

const Shell = ({ title, children }) => (
  <div className="min-h-screen bg-white">
    <div className="mx-auto max-w-3xl px-4 py-16 lg:px-8">
      <Link to="/" className="inline-flex items-center gap-2 text-sm font-bold text-[var(--navy)] hover:text-[var(--red)]" data-testid="legal-back">
        <ArrowLeft size={16} /> Back to Home
      </Link>
      <h1 className="mt-6 font-head text-4xl font-extrabold tracking-tight text-[var(--navy)]">{title}</h1>
      <div className="prose mt-8 max-w-none text-[var(--slate)] [&_h2]:mt-8 [&_h2]:font-head [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-[var(--navy)] [&_li]:mt-1 [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6">
        {children}
      </div>
    </div>
  </div>
);

export const PrivacyPolicy = () => (
  <Shell title="Privacy Policy">
    <p>This Privacy Policy explains how Jan Seva Hospital ("we", "us") handles information you provide through the enquiry form on this website.</p>
    <h2>What information we collect</h2>
    <ul>
      <li>Your name and phone number.</li>
      <li>The service you are enquiring about and a preferred consultation date (optional).</li>
      <li>Any message you choose to share with us (optional).</li>
    </ul>
    <p>Please do not submit Aadhaar numbers, financial details or confidential medical records through this form.</p>
    <h2>Why we collect it</h2>
    <p>We collect this information solely to respond to your enquiry, schedule appointments and provide information about our services.</p>
    <h2>How we may contact you</h2>
    <p>By submitting the form and giving consent, you agree that we may contact you by phone, WhatsApp or call regarding your enquiry.</p>
    <h2>Data sharing</h2>
    <p>We do not sell your information. We do not share it with third parties for marketing purposes.</p>
    <h2>Correction &amp; deletion</h2>
    <p>You may request correction or deletion of your information at any time by contacting us at {CONFIG.email} or by calling +91 {CONFIG.phonePrimary}.</p>
    <h2>Privacy enquiries</h2>
    <p>For any privacy-related questions, contact us at {CONFIG.email} or +91 {CONFIG.phonePrimary}.</p>
  </Shell>
);

export const MedicalDisclaimerPage = () => (
  <Shell title="Medical Disclaimer">
    <p>{DISCLAIMER.en}</p>
    <p className="lang-hi">{DISCLAIMER.hi}</p>
    <h2>No doctor–patient relationship</h2>
    <p>Using this website or submitting an enquiry does not create a doctor–patient relationship. Clinical decisions are made only after an in-person assessment by a qualified doctor.</p>
    <h2>Emergencies</h2>
    <p>This website does not provide emergency medical diagnosis. In a life-threatening emergency, call the hospital or visit the nearest emergency department immediately.</p>
  </Shell>
);

export const TermsPage = () => (
  <Shell title="Terms of Use">
    <p>By accessing this website you agree to the following terms.</p>
    <h2>Informational purpose</h2>
    <p>Content on this website is for general information about Jan Seva Hospital and its services. It does not constitute medical advice or guaranteed outcomes.</p>
    <h2>Accuracy</h2>
    <p>We aim to keep information accurate and up to date, but details such as timings and services may change without notice.</p>
    <h2>External links</h2>
    <p>Links to third-party services (such as Google Maps and WhatsApp) are provided for convenience and are governed by their own terms.</p>
    <h2>Contact</h2>
    <p>For questions about these terms, contact +91 {CONFIG.phonePrimary} or {CONFIG.email}.</p>
  </Shell>
);

export const NotFound = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 text-center">
    <p className="font-head text-7xl font-extrabold text-[var(--navy)]">404</p>
    <p className="mt-3 text-lg font-semibold text-[var(--slate)]">Sorry, this page could not be found.</p>
    <Link to="/" className="mt-6 rounded-full bg-[var(--navy)] px-6 py-3 text-sm font-bold text-white transition-all hover:scale-[1.03]" data-testid="notfound-home">
      Go to Homepage
    </Link>
  </div>
);
